"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmChip = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.SmChip = react_1.default.forwardRef((_a, ref) => {
    var { selected = false, text, variant = 'primary', icon, className } = _a, props = __rest(_a, ["selected", "text", "variant", "icon", "className"]);
    const chipClassName = (0, classnames_1.default)('c-button -pills', `${selected ? '-selected' : '-outlined -unselected'}`, '-chip', `-${variant}`, className);
    return (react_1.default.createElement("button", Object.assign({}, props, { ref: ref, className: chipClassName, type: "button" }),
        text,
        react_1.default.createElement("span", { className: "ml-2 d-flex justify-content-center" }, icon)));
});
//# sourceMappingURL=index.js.map